import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import VendorPublicProfile from "./VendorPublicProfile";
import "./VendorProfileModal.css";

const CLOSE_ANIMATION_MS = 220;

export default function VendorProfileModal() {
  const navigate = useNavigate();
  const [isClosing, setIsClosing] = useState(false);

  const close = () => {
    if (isClosing) return;
    setIsClosing(true);
    setTimeout(() => navigate(-1), CLOSE_ANIMATION_MS);
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`vpm-screen ${isClosing ? "vpm-screen--closing" : ""}`}>
      {/* Top Left Back Button */}
      <button className="vpm-back-btn" onClick={close} aria-label="Back to Directory">
        <ArrowLeft size={18} />
        <span>Back</span>
      </button>

      <div className="vpm-scroll">
        <VendorPublicProfile />
      </div>
    </div>
  );
}